import { Zap, BookOpen, Medal } from "lucide-react";

const PILLARS = [
  { icon: Zap, hi: "दौड़ो", en: "Run" },
  { icon: Medal, hi: "जीतो", en: "Win" },
  { icon: BookOpen, hi: "पढ़ो", en: "Read" },
];

export const Motivation = () => (
  <section className="motivation" data-testid="motivation-section">
    <div className="gp-container relative py-12 sm:py-16">
      <p className="eyebrow !text-white/85">प्रेरणा · Motivation</p>
      <h2 className="mt-3 font-hi text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white leading-snug max-w-3xl" data-testid="motivation-quote">
        खेलेंगे मानपुर के युवा,<br /><span className="text-[#0b1a33]">बढ़ेगा गाँव का गौरव!</span>
      </h2>
      <p className="mt-3 text-white/85 max-w-xl">The youth of Manpur will play, and the village will shine with pride.</p>
      <div className="mt-8 grid grid-cols-3 gap-3 max-w-lg">
        {PILLARS.map(({ icon: Icon, hi, en }) => (
          <div key={en} className="pillar">
            <Icon size={22} className="text-white" />
            <div className="mt-2 font-hi font-bold text-white text-lg">{hi}</div>
            <div className="text-[11px] uppercase tracking-widest text-white/75">{en}</div>
          </div>
        ))}
      </div>
      <p className="mt-8 font-hi text-white/90 text-base md:text-lg border-l-4 border-white pl-4">
        एक संकल्प, एक संदेश — भारत बने पुस्तकालयों का देश!
      </p>
    </div>
  </section>
);
